<template>
  <div class="animated" v-if="!loading && instrument_instance && process">
    <b-progress :max="max" height="1rem" class="bg-gray-400">
      <b-progress-bar
        :value="value"
        :variant="variant"
        class="text-white"
        align-h="center"
      >
        <strong>{{ value }} / {{ max }}</strong>
      </b-progress-bar>
    </b-progress>
  </div>
</template>

<script>
import InstrumentInstanceModel from "@/models/lab/InstrumentInstanceModel";
import InstrumentInstanceScheduleCollection from "@/collections/lab/InstrumentInstanceScheduleCollection";
import ProcessScheduleModel from "@/models/lab/ProcessScheduleModel";
import SampleCollection from "@/collections/lab/SampleCollection";

export default {
  name: "InstrumentCapacityBar",
  props: {
    instrument_instance: {
      type: InstrumentInstanceModel,
      default: () => null,
    },
    process: {
      type: ProcessScheduleModel,
      default: () => null,
    },
  },
  data() {
    return {
      loading: true,
      iis: new InstrumentInstanceScheduleCollection(),
    };
  },
  computed: {
    max() {
      return this.dailyCapacity(this.instrument_instance);
    },
    value() {
      return this.getSamples().models.length;
    },
    variant() {
      if (this.value / this.max >= 0.8) {
        return "success";
      } else if (this.value / this.max >= 0.6) {
        return null;
      } else if (this.value / this.max >= 0.4) {
        return "warning";
      } else {
        return "danger";
      }
    },
  },
  methods: {
    async init() {
      await this.fetchInstrumentInstanceSchedules();
    },

    getSamples() {
      const samples = new SampleCollection();

      if (this.process && this.iis.length) {
        this.iis.each((iis_inst) => {
          if (iis_inst.instrument_instance) {
            const instrument_instance = iis_inst.instrument_instance;

            if (instrument_instance.id === this.instrument_instance.id) {
              samples.add(iis_inst.sample);
            }
          }
        });
      }
      return samples;
    },
    /**
     * Fetch iis models
     */
    fetchInstrumentInstanceSchedules() {
      let filter = this.iis.getFilter();
      let connections = ["instrument", "instrument_instance", "sample"];
      connections.forEach((connection) => {
        filter.connectionAdd(connection);
      });
      filter.filterEquals("process_schedule_id", this.process.id);
      filter.cacheStaticFilters();
      return Promise.all([this.iis.fetch()]);
    },
    runtimeSeconds({ runtime_display, runtime }) {
      switch (runtime_display) {
        case "hours":
          return Math.abs(runtime) * 3600;
        case "minutes":
          return Math.abs(runtime) * 60;
        case "seconds":
          return Math.abs(runtime);
        default:
          return null;
      }
    },
    dailyCapacity(instrument_instance) {
      const runtime_seconds = this.runtimeSeconds(instrument_instance) || 1;

      return Math.floor(32400 / runtime_seconds) * instrument_instance.capacity;
    },
  },
  mounted() {
    this.loading = true;
    this.init().then(() => {
      // indicate loading complete
      this.loading = false;
    });
  },
};
</script>
